import { URL_UPDATE_MENU_TAB } from 'constants/urls';

async function updateTabApi(tabs) {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify(tabs),
	};

	const res = await fetch(URL_UPDATE_MENU_TAB, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const { msg } = await res.json();
		return msg;
	}
}

export default updateTabApi;
